import React from 'react';

const DisbursementMethod: React.FC = () => {
  return null;
};

export default DisbursementMethod;
